import React, { useState, useEffect } from 'react';
// React core library and hooks for state management and side effects

import { fetchFormData } from '../api/rulesAndData';
// Function to fetch form rules/data from your backend API

import FormField from '../components/FormField';
// Component that renders individual input fields

import MyButton from '../components/MyButton';
// Component that renders styled buttons

import { FORM_FIELDS } from '../utils/formConfig';
// Array of form field definitions (name, type, label, etc.)

import { validateForm, createInitialFormState, loadValidationRules } from '../utils/form';
// validateForm -> function to check input validity
// createInitialFormState -> initializes the formData state object
// loadValidationRules -> abstracted function to fetch rules (from API)

const TestForm = () => {
  // -----------------------------
  // STATE VARIABLES
  // -----------------------------
  const [formData, setFormData] = useState(
    createInitialFormState(FORM_FIELDS)
  );
  // formData stores current values of all fields
  // Initialized based on FORM_FIELDS (e.g., { username: '', email: '' })

  const [errors, setErrors] = useState({});
  // errors stores validation errors for each field (e.g., { email: 'Invalid email' })

  const [rules, setRules] = useState(null);
  // rules will store validation rules fetched from backend

  // -----------------------------
  // HANDLER: Input change
  // -----------------------------
  const handleChange = (e) => {
    const { name, value } = e.target;
    // Update only the changed field, keep others intact
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  // -----------------------------
  // HANDLER: Form submission
  // -----------------------------
  const handleSubmit = (e) => {
  e.preventDefault();

  if (!rules) {
    alert('Rules are still loading, please wait...');
    return;
  }

  const validationErrors = validateForm({ formData, rules });
  if (Object.keys(validationErrors).length) {
    setErrors(validationErrors);
    return;
  }

  alert('All validations passed!');
};


  // -----------------------------
  // EFFECT: Load validation rules
  // -----------------------------
  useEffect(() => {
    let mounted = true; // Flag to prevent updating state if component unmounts

    async function fetchRules() {
      try {
        const data = await loadValidationRules();
        if (mounted && data) setRules(data); 
        // Update rules state only if component is still mounted
      } catch {
        // If fetch fails, fallback to basic/default validation
      }
    }

    fetchRules();

    // Cleanup function to mark component as unmounted
    return () => (mounted = false);
  }, []); // Empty dependency array → run once on mount

  // -----------------------------
  // RENDER
  // -----------------------------
  return (
    <div style={{ maxWidth: '400px', margin: '0 auto', padding: '20px' }}>
      <h2>Test Form</h2>

      <form onSubmit={handleSubmit}>
        {/* Render form fields dynamically based on FORM_FIELDS */}
        {FORM_FIELDS.map((field) => (
          <FormField
            key={field.name} // Required unique key for React
            {...field} // Spread all field properties (name, label, type, etc.)
            value={formData[field.name]} // Bind current value
            error={errors[field.name]} // Show field-specific error if any
            onChange={handleChange} // Common change handler
          />
        ))}

        {/* Buttons */}
        <MyButton text="Validate" type="submit" variant="primary" />
        <MyButton text="Cancel" type="button" variant="secondary" />
        <MyButton text="Delete" type="button" variant="danger" />
      </form>
    </div>
  );
};

// Export component so it can be used in other files
export default TestForm;
